import { useRef, useState } from "react";
import { motion } from "framer-motion";

const VinylCover = () => {
  const ref = useRef(null);
  const [tilt, setTilt] = useState({ rx: 0, ry: 0 });
  const [hover, setHover] = useState(false);

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    setTilt({ rx: -py * 12, ry: px * 14 });
  };

  return (
    <div
      ref={ref}
      data-testid="book-cover-3d"
      className="relative w-[280px] sm:w-[340px] lg:w-[400px] aspect-[0.74] mx-auto"
      style={{ perspective: 1100 }}
      onMouseMove={onMove}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => { setTilt({ rx: 0, ry: 0 }); setHover(false); }}
    >
      <div className="vinyl-disc absolute top-1/2 left-1/2 w-[92%] aspect-square -translate-y-1/2 transition-transform duration-700 ease-out"
        style={{ transform: `translate(${hover ? "-18%" : "-50%"}, -50%)` }}>
        <div className="vinyl-label absolute top-1/2 left-1/2 w-[30%] aspect-square -translate-x-1/2 -translate-y-1/2 rounded-full" />
      </div>
      <motion.div
        className="relative z-10 w-full h-full rounded-sm overflow-hidden glow-orange"
        style={{ transformStyle: "preserve-3d" }}
        animate={{ rotateX: tilt.rx, rotateY: tilt.ry }}
        transition={{ type: "spring", stiffness: 120, damping: 14 }}
      >
        <img src="/img/cover_front.png" alt="Copertina Una vita da DJ" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-white/5 pointer-events-none" />
      </motion.div>
    </div>
  );
};

export default VinylCover;
